export const defaultArgs = {
  children: 'Success Message',
  color: 'success',
}

export const argTypes = {}
